import { render, staticRenderFns } from "./MessageFilters.vue?vue&type=template&id=4197bbf1&scoped=true&"
import script from "./MessageFilters.vue?vue&type=script&lang=ts&"
export * from "./MessageFilters.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./MessageFilters.vue?vue&type=style&index=1&id=4197bbf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4197bbf1",
  null
  
)

export default component.exports